/** Resolve notification title/body from i18n keys (user content in preview stays as-is). */

function interpolate(template, params, statusLabel) {
  if (!template) return "";
  return template.replace(/\{(\w+)\}/g, (_, key) => {
    if (key === "status" && params.status && statusLabel) {
      return statusLabel(params.status);
    }
    const v = params[key];
    return v == null ? "" : String(v);
  });
}

export function formatNotification(n, t, statusLabel) {
  const params = n?.i18n_params || {};
  const key = n?.i18n_key || n?.type;
  const types = t?.notifications?.types || {};
  const tpl = types[key];
  if (tpl) {
    return {
      title: interpolate(tpl.title, params, statusLabel),
      body: interpolate(tpl.body, params, statusLabel),
    };
  }
  return { title: n?.title || "", body: n?.body || "" };
}

export function notificationLink(n, user) {
  if (n?.case_type && n?.case_id) {
    const isStaff = user?.role === "admin" || user?.role === "reviewer";
    if (isStaff) {
      return { pathname: "/admin", search: `?open=${n.case_type}:${n.case_id}` };
    }
    return {
      pathname: "/dashboard",
      search: `?open=${n.case_type}:${n.case_id}`,
    };
  }
  if (n?.link_path) {
    return { pathname: n.link_path };
  }
  return { pathname: "/dashboard" };
}
